import { UserProfileServiceClient } from '@playq/octopus2-auth';

import { transport } from '../../core';

export const userProfileService = new UserProfileServiceClient(transport);
